import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

const webPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '亚洲免费在线 — 资源汇总平台首页',
  description: '亚洲免费在线是获取亚洲优质免费网络资源的首选平台，涵盖亚洲各国免费在线内容、工具与服务',
  url: 'https://akeliusi.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '亚洲免费在线',
    url: 'https://akeliusi.cn/',
  },
};

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <FeaturedSection />
          <CategorySection />
          <ArticleList />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}